import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { ChartModule } from 'primeng/chart';
import { CalendarModule } from 'primeng/calendar';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FileUploadModule } from 'primeng/fileupload';
import { SharedModule } from 'eddydata-lib';
import { PagamentoLstComponent } from './pagamento-lst/pagamento-lst.component';
import { PagamentoShwComponent } from './pagamento-shw/pagamento-shw.component';
import { PagamentoRoutingModule } from './pagamento-routing.module';

@NgModule({
  declarations: [
    PagamentoLstComponent,
    PagamentoShwComponent,
  ],
  imports: [
    CommonModule,
    PagamentoRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    ChartModule,
    IMaskModule,
    ListboxModule,
    TableModule,
    ProgressSpinnerModule,
    ToastModule,
    RadioButtonModule,
    FileUploadModule
  ]
})
export class PagamentoModule { }
